import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";

import { GridContainer } from "@/components/layout/GridContainer";
import { RichTextField } from "@/components/typography/RichTextField";
import { cn } from "@/lib/utils";

type InfoCardSectionStoryblok = {
  subline?: string;
  headline?: string;
  text?: string;
  alignment?: "left" | "center";
  cards?: any[];
  _uid: string;
  component: "info_card_section";
  [k: string]: any;
};

type InfoCardSectionProps = {
  blok: InfoCardSectionStoryblok;
};

const InfoCardSection = ({ blok }: InfoCardSectionProps) => {
  if (!blok.cards || blok.cards.length === 0) return null;

  const isSingle = blok.cards.length === 1;
  const centered = blok.alignment === "center";

  return (
    <div className="md:pt-8 mb-4 md:mb-6" {...storyblokEditable(blok)}>
      {(blok.subline || blok.headline || blok.text) && (
        <div className="max-w-7xl mx-auto px-4 md:px-8 mb-6 lg:px-0">
          <div className={cn(
            "md:max-w-[66%] lg:max-w-[50%]",
            centered ? "mx-auto text-center" : "mx-auto md:mx-0 lg:ml-[16.67%]",
          )}>
            {(blok.subline || blok.headline) && (
              <div className="flex flex-col gap-1">
                {blok.subline && <p className="text-copy-bold">{blok.subline}</p>}
                {blok.headline && <h2 className="text-headline-xl">{blok.headline}</h2>}
              </div>
            )}
            {blok.text && (
              <RichTextField value={blok.text} className="text-copy mt-4" />
            )}
          </div>
        </div>
      )}
      <GridContainer className="!px-0">
        {isSingle ? (
          <div className="col-span-12 flex justify-center">
            <div className="w-full md:w-1/2">
              <StoryblokComponent
                blok={blok.cards[0]}
                key={blok.cards[0]._uid}
              />
            </div>
          </div>
        ) : (
          blok.cards.map((nestedBlok: any) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        )}
      </GridContainer>
    </div>
  );
};

export default InfoCardSection;
